module.exports = __webpack_public_path__ + "static/media/13_MBTA - Boston.9ae2cdbb.jpg";